import styled from 'styled-components';
import DefaultButton from '../../StoraEnsoComponents/Button';
import { getFeatureTypeIcon } from '../../../utils/feature';
import RowExpandButton from '../../DataTable/RowExpandButton';
import ReactTooltip from 'react-tooltip';

const Button = styled(DefaultButton)`
  padding: 0 12px;

  span {
    padding: 4px 0;
  }
`;

const TypeIconWrapper = styled.div`
  height: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const getColumns = ({onItemDelete}) => [
  {
    id: 'expander',
    Header: '',
    customHeaderWidth: 40,
    customAlignment: 'center',
    Cell: ({ row }) => <RowExpandButton row={row} />,
  },
  {
    id: 'id',
    Header: 'Id',
    accessor: 'id',
    customHeaderWidth: 60,
  },
  {
    id: 'featureType',
    Header: 'Type',
    accessor: 'feature_type',
    customHeaderWidth: 80,
    Cell: ({ value, row: { original: { profile_type }}}) =>
    <>
      <ReactTooltip type='light'/>
      <TypeIconWrapper>{getFeatureTypeIcon({featureType: value, profileType: profile_type})}</TypeIconWrapper>
      </>
  },
  {
    id: 'name',
    Header: 'Name',
    accessor: 'name',
    Cell: ({ value }) =>  value || '-',
  },
  {
    id: 'logLength',
    Header: 'Log length',
    accessor: 'log_length',
    customAlignment: 'right',
    Cell: ({ value }) =>  <span>{value}&nbsp;m</span>,
  },
  {
    id: 'coeficient',
    Header: 'Coeficient',
    accessor: 'coeficient',
    customAlignment: 'right',
  },
  {
    id: 'woodType',
    Header: 'Wood type',
    accessor: 'type',
    Cell: ({ value }) =>  value || '-',
  },
  {
    id: 'heightGround',
    Header: 'Height ground',
    accessor: 'height_ground',
    customAlignment: 'right',
    Cell: ({ value }) =>  <span>{value}&nbsp;m</span>,
  },
  {
    id: 'volume',
    Header: 'Volume',
    accessor: 'volume_m3',
    customAlignment: 'right',
      Cell: ({ value }) => <span className="volume-value">{value}&nbsp;m<sup>3</sup></span>,
  },
  {
    id: 'volumeCoefM3',
    Header: 'Volume coef',
    accessor: 'volume_coef_m3',
    customAlignment: 'right',
      Cell: ({ value }) => <span className="volume_coef-value">{value}&nbsp;m<sup>3</sup></span>,
  },
  {
    Header: '',
    accessor: 'none',
    disableSortBy: true,
    customAlignment: 'right',
    Cell: ({
      row: { original: { id } }
    }) => <Button
            kind="negative"
            onClick={(e) => {
              e.stopPropagation();
              onItemDelete(id);
            }}
            size="sm">Delete</Button>,
  },
];

export default getColumns;